import { Injectable } from "@angular/core";
import { BrandEntity, BrandEntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  RoomBrandCreateRequestDTO,
  RoomBrandCreateResponseDTO,
  RoomBrandDeleteRequestDTO,
  RoomBrandUpdateRequestDTO,
  RoomBrandUpdateResponseDTO,
  RoomBrandUseRequestDTO
} from "../dto";

@Injectable()
export class RoomBrandService {
  constructor(private readonly apiService: ApiService) {}

  roomBrandCreate(roomBrandCreateRequestDTO: RoomBrandCreateRequestDTO) {
    return this.apiService
      .post<{ brand: BrandEntityRaw }>(
        `rooms/${roomBrandCreateRequestDTO.data.roomId}/brands`,
        { brandTitle: roomBrandCreateRequestDTO.data.brandTitle }
      )
      .pipe(
        map(
          (_) =>
            new RoomBrandCreateResponseDTO({
              brand: new BrandEntity(_.brand)
            })
        )
      );
  }

  roomBrandDelete(
    roomBrandDeleteRequestDTO: RoomBrandDeleteRequestDTO
  ): Observable<void> {
    return this.apiService.delete<void>(
      `rooms/${roomBrandDeleteRequestDTO.data.roomId}/brands/${roomBrandDeleteRequestDTO.data.brandId}`
    );
  }

  roomBrandUpdate(
    roomBrandUpdateRequestDTO: RoomBrandUpdateRequestDTO
  ): Observable<RoomBrandUpdateResponseDTO> {
    const { roomId, brandId, brandTitle } = roomBrandUpdateRequestDTO.data;

    return this.apiService
      .put<{ brand: BrandEntityRaw }>(`rooms/${roomId}/brands/${brandId}`, {
        brandTitle
      })
      .pipe(
        map(
          (_) =>
            new RoomBrandUpdateResponseDTO({
              brand: new BrandEntity(_.brand)
            })
        )
      );
  }

  roomBrandUse(
    roomBrandUseRequestDTO: RoomBrandUseRequestDTO
  ): Observable<void> {
    return this.apiService.post<void>(
      `rooms/${roomBrandUseRequestDTO.data.roomId}/brands/${roomBrandUseRequestDTO.data.brandId}/use`,
      {}
    );
  }
}
